import { ExamSubject, OrderDirection } from 'generated/graphql'
import { ExamQuestionSelectOptionType } from '@app.feature/exam/gsat2024-2/types/examQuestionType'

const SUBJECT_OPTIONS: Array<ExamQuestionSelectOptionType> = [
  { label: '수리', value: ExamSubject.MATH },
  {
    label: '추리',
    value: ExamSubject.REASONING,
  },
]

const ORDER_DIRECTION_OPTIONS: Array<ExamQuestionSelectOptionType> = [
  {
    label: '오름차순',
    value: OrderDirection.ASC,
  },
  {
    label: '내림차순',
    value: OrderDirection.DESC,
  },
]

const DROP_DOWN_DATA = {
  SUBJECT_OPTIONS,
  ORDER_DIRECTION_OPTIONS,
}

export default DROP_DOWN_DATA
